import { Flex, Typography } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

export const CommentarySubSection = ({
  title,
  subtitle,
  children,
}: PropsWithChildren<{ title: string; subtitle: string }>) => {
  return (
    <Flex flexDirection="column" gap={4}>
      <Flex flexDirection="column" gap={2}>
        <Typography variant="h2">{title}</Typography>
        <Typography variant="body1">{subtitle}</Typography>
      </Flex>

      {children}
    </Flex>
  );
};
